module.exports = __webpack_public_path__ + "static/media/mk.bbfeaa45.png";